<template>
  <div class="text-center team-join-modal position-relative mx-auto">
    <Subheader v-if="title" :text="title" />
    <TextBlock v-if="text" variant="secondary" :text="text" />
    <div
      class="d-flex align-items-center justify-content-center mt-6 row no-gutters"
    >
      <HeraFormBtn
        class="btn-accent-simple flex-shrink-0 flex-grow-1 col"
        :disabled="pickTeamButtonDisabled || isLoading"
        @click.prevent="$emit('joinWithExistingTeam')"
      >
        {{ $$t('Join with team') }}
      </HeraFormBtn>
      <TextBlock tag="div" variant="secondary" class="spacer mx-4 col-auto">{{
        $$t('Or')
      }}</TextBlock>
      <HeraFormBtn
        class="btn-accent-simple flex-shrink-0 flex-grow-1 col"
        :disabled="createTeamButtonDisabled || isLoading"
        @click.prevent="$emit('joinWithNewTeam')"
      >
        {{ $$t('Create and join') }}
      </HeraFormBtn>
    </div>
  </div>
</template>

<script>
import HeraFormBtn from '@/components/atoms/HeraFormBtn';
import TextBlock from '@/components/atoms/TextBlock';
import Subheader from '@/components/atoms/Subheader';
import { translate } from '@/mixins/translate';

export default {
  name: 'TeamJoinOptionsModal',
  components: { HeraFormBtn, Subheader, TextBlock },
  mixins: [translate('_web_tournament_statusbar')],
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    pickTeamButtonDisabled: {
      type: Boolean,
      default: false,
    },
    createTeamButtonDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.team-join-modal {
  width: 100%;
  max-width: 360px;
  button {
    max-width: 50%;
  }
}
</style>
